import { therapyPlanningAction } from '../../actions/constant';

const { GET_MDS_ASSESSMENT_FAILURE, GET_MDS_ASSESSMENT_SUCCESS, GET_MDS_ASSESSMENT_LOADING } =
  therapyPlanningAction;

const intitialstate: object = {
  isError: false,
  errorMessage: '',
  response: null,
  loading: false,
};

export const getMDSAssessmentReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_MDS_ASSESSMENT_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isError: false,
        errorMessage: '',
        loading: false,
      };
    }

    case GET_MDS_ASSESSMENT_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };
    case GET_MDS_ASSESSMENT_LOADING:
      return {
        ...intitialstate,
        loading: true,
      };
    default:
      return state;
  }
};
